/**
 * The contextual page header: what this page is, how it is doing, and the one
 * thing you most likely came here to do.
 *
 * `status` sits beside the title rather than below it so the page's state is
 * read in the same glance as its name — on an operations console the answer to
 * "is this fine" should never require scrolling.
 */

import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  actions,
  status,
  breadcrumb,
}: {
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  /** A badge or short phrase describing the page's current state. */
  status?: ReactNode;
  /** Where this page sits, for detail routes reached from a list. */
  breadcrumb?: ReactNode;
}) {
  return (
    <header className="page-header">
      <div className="page-header__text">
        {breadcrumb ? <div className="page-header__crumb">{breadcrumb}</div> : null}
        <div className="page-header__title-row">
          <h1 className="page-title">{title}</h1>
          {status ? <span className="page-header__status">{status}</span> : null}
        </div>
        {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
      </div>
      {actions ? <div className="page-header__actions">{actions}</div> : null}
    </header>
  );
}
